import { Button, Typography } from '@mui/material';
import { useLocales } from 'src/locales';

// eslint-disable-next-line react/prop-types
function ExploreBtn({ sx = {}, ...props }) {
  const { t } = useLocales();

  return (
    <Button
      sx={{
        width: 138,
        height: 38,
        padding: '19px',
        background: '#000',
        '&:hover': {
          background: '#000',
        },
        ...sx,
      }}
      {...props}
    >
      <Typography fontSize={15} color="#FFF">
        {t('string_004')}
      </Typography>
    </Button>
  );
}

export default ExploreBtn;
